// extracted by mini-css-extract-plugin
export default {"headerWrpper":"HeaderText_headerWrpper__n7Yuu","header":"HeaderText_header__XGSfm","brightFont":"HeaderText_brightFont__J0XWN"};